import { Injectable } from "@angular/core";
import { BehaviorSubject, combineLatest } from "rxjs";
import { map } from "rxjs/operators";
import { NextcloudFile } from "src/app/classes";
import { FileService } from "../../../services/file.service";

@Injectable()
export class NextcloudExplorerComponentService {

    private _visibleExtensions = new BehaviorSubject(null);
    visibleExtensions$ = this._visibleExtensions.asObservable();

    private _files = new BehaviorSubject<NextcloudFile[]>([]);
    files$ = this._files.asObservable();

    private _showFolders = new BehaviorSubject(true);
    showFolders$ = this._showFolders.asObservable();

    private _filter = new BehaviorSubject<string>(null);
    filter$ = this._filter.pipe(map((filter: string) => typeof (filter) === 'string' ? filter.trim().toLowerCase() : null));

    private _limit = new BehaviorSubject<number>(40);
    limit$ = this._limit.asObservable();

    displayedFiles$ = combineLatest([this.visibleExtensions$, this.files$, this.showFolders$, this.filter$, this.limit$]).pipe(map(([types, files, showFolders, filter, limit]) => {
        let filtered = [];
        if (Array.isArray(files)) {
            for (let file of files) {
                if(filtered.length >= limit) break;
                if (!file) continue;
                let fileNameArray = FileService.getFileName(file.href).split('.');
                if (filter && fileNameArray[0].trim().toLowerCase().indexOf(filter) === -1) continue;
                if (fileNameArray.length === 1){
                    if(showFolders) filtered.push(file);
                    continue;
                }
                if(types === null || (typeof fileNameArray[1] === 'undefined' && types.indexOf('folder') > -1) || types.indexOf(fileNameArray[1]) > -1) filtered.push(file);
            }
        }
        return filtered;
    }));
    hasMoreEntries$ = combineLatest([this.files$, this.limit$]).pipe(map(([files, limit]) => Array.isArray(files)? files.length > limit: false));

    constructor() { }

    loadMore = () => this.setLimit(this._limit.value + 20);
    setFiles = (files: NextcloudFile[]) => this._files.next(files);
    setFilter = (filter: string) => this._filter.next(filter);
    setLimit = (limit: number = 40) => this._limit.next(limit);
    setVisibleTypes = (types: string[]) => this._visibleExtensions.next(types);
}